// Presentational surfaces for the update-control client. State decided by useUpdateControl.

const DEFAULT_SOFT = "A new version of the console is available.";
const DEFAULT_HARD =
  "This version of the console is no longer supported. Reload to continue.";

/** Slim, non-dismissible "update available" bar shown above the shell (soft level). */
export function UpdateBanner({
  message,
  onReload,
}: {
  message: string | null;
  onReload: () => void;
}) {
  return (
    <div className="updbar" role="status">
      <span className="updbar__text">{message ?? DEFAULT_SOFT}</span>
      <button className="updbar__btn" type="button" onClick={onReload}>
        Refresh now
      </button>
    </div>
  );
}

/** Full-screen blocking overlay shown when the client is below min-supported / force_update set. */
export function UpdateBlock({
  message,
  onReload,
}: {
  message: string | null;
  onReload: () => void;
}) {
  return (
    <div className="updblock" role="alertdialog" aria-modal="true" aria-labelledby="updblock-title">
      <div className="updblock__card">
        <h1 id="updblock-title" className="updblock__title">
          Update required
        </h1>
        <p className="updblock__text">{message ?? DEFAULT_HARD}</p>
        <button className="updblock__btn" type="button" onClick={onReload}>
          Reload
        </button>
      </div>
    </div>
  );
}
